module.exports = __webpack_public_path__ + "img/Flag_of_Vietnam.6a8e16c8.svg";